import {
  programmaticAdviceRecoInitialState,
  type ProgrammaticAdviceRecoState,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.model';
import { commonProgrammaticAdviceRecoReducer } from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.reducer';
import { selectProgrammaticAdviceReco } from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.selectors';
import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';
import type { SpartacuxDigitalAdviceState } from '@/domains/digitalAdvice/digitalAdvice.model';
import {
  FETCHING_CATEGORIZED_SEARCH,
  RESET_SELECTED_CATEGORY,
  type FetchingCategorizedSearch,
  type ResetSelectedCategory,
} from '@/productDiscovery/Listings/technicalFilters/actions';

type ClientRecommendationReducer = (
  state: ProgrammaticAdviceRecoState,
  action:
    | HydrateAction<SpartacuxDigitalAdviceState>
    | ResetSelectedCategory
    | FetchingCategorizedSearch,
) => Partial<ProgrammaticAdviceRecoState>;

export const clientProgrammaticAdviceRecoReducer: ClientRecommendationReducer =
  (state = programmaticAdviceRecoInitialState, action) => {
    switch (action.type) {
      case FETCHING_CATEGORIZED_SEARCH:
      case RESET_SELECTED_CATEGORY:
        return { ...state, data: [] };
      case HYDRATE:
        return { ...(selectProgrammaticAdviceReco(action.state) || {}) };
      default:
        return commonProgrammaticAdviceRecoReducer(state, action);
    }
  };
